module.exports = __webpack_public_path__ + "static/media/arrow-down.3e9c517e.svg";